// extracted by mini-css-extract-plugin
export default {"form_credit":"FormCredit-module__form_credit--Z4XoA","form_credit__payment":"FormCredit-module__form_credit__payment--d_d5a"};